export default (theme, styles) => ({
    location: {
        display: "flex",
        flexWrap: "noWrap",
        alignItems: "center",
        color: "#000"
    },
    checkbox: {
        position: "absolute",
        right: 5,
        top: theme.spacing(3)
    },
    icon: {
        width: 24,
        height: 24,
        marginLeft: theme.spacing(1)
    },
    ...styles
});